<template>
    <div v-if="!isNaN(seconds)">
        <div class="time" v-if="isEnded">
            Beendet
        </div>
        <div class="time" :class="{red: isLastMinute}" v-else>
            <span v-if="days > 0">{{ days }}T</span>
            <span v-if="(days > 0 ) || (days == 0 && hours > 0)">{{ hours }}Std</span>
            <span>{{ minutes }}Min</span>
            <span v-if="days == 0">{{ seconds }}Sek</span>
            <div class="endDate" v-if="textdate != ''">
                ({{ dateInText }})
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            productid: {
                type: [Number,String],
                default: ''
            },
            date: {
                type: [String],
                default: ''
            },
            textdate: {
                type: [String],
                default: ''
            }
        },

        data () { 
            return {
                dateEnd: null,
                dateInText: "",
                days: null,
                hours: null,
                minutes: null,
                seconds: null,
                isEnded: null,
                isLastMinute: false,
                ticks: 0,
                starttime: null,
                timer: 0
            }
        },

        methods: {
            updateRemaining (distance) {
                this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
                this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
                this.seconds = Math.floor((distance % (1000 * 60)) / 1000)

                if(this.days == 0 && this.hours == 0 && this.minutes == 0) {
                    this.isLastMinute = true;
                } else {
                    this.isLastMinute = false;
                }
            },

            tick () {
                this.ticks++;
                let endDate = moment(this.dateEnd)
                const currentTime = moment(this.starttime).add(this.ticks, 'seconds')
                const distance = Math.max(endDate - currentTime, 0)
                this.updateRemaining(distance)

                if (distance === 0) {
                    clearInterval(this.timer)
                    this.isEnded = true;
                    if(!isNaN(this.seconds)) {
                        App.event.fire('timer.ended', {
                            ended: true,
                            productId: this.productid
                        });
                        var that = this;
                        setTimeout(function(){
                            $('#product'+that.productid).css("display", "none");
                        }, 5000);
                    }
                }
                else {
                    if(!isNaN(this.seconds)) {
                        App.event.fire('timer.ended', {
                            ended: false,
                            productId: this.productid
                        });
                    }
                }
            },

            setTimeFromServer() {
                new Form().get('/api/time')
                .then((response) => {
                    this.starttime = response;
                })
            }
        },

        mounted () {
            App.socket.on('12meins-channel:App\\Events\\UserBid', (data) => {
                if(this.productid == data.productId) {
                    this.ticks = 0;
                    this.starttime = data.timer;
                    this.dateEnd = data.endtimer;
                    this.dateInText = moment(data.endtimer).format('DD.MM.YYYY H:mm');
                }  
            });

            App.socket.on('12meins-channel:timerCorrect', (data) => {
                if(moment(this.starttime).add(5, 'seconds') < moment(data.timer))
                {
                    location.reload();
                }
                this.ticks = 0;
                this.starttime = data.timer;
            });

            this.tick();
            this.timer = setInterval(this.tick.bind(this), 1000);
        },

        destroy () {
            clearInterval(this.timer)
        },

        created () {
            this.dateEnd = this.date;
            this.dateInText = this.textdate;
            this.setTimeFromServer();
        }
    }
</script>
